import { FaBuilding, FaBlog, FaRunning, FaCogs, FaUser } from "react-icons/fa";
import { HiLightBulb } from "react-icons/hi";
import { RiCustomerService2Fill } from "react-icons/ri";
import { MdDashboard } from "react-icons/md";
import { BsFillMegaphoneFill } from "react-icons/bs";
import { IconType } from "react-icons/lib";

type ItemType = {
  key: number;
  link: string;
  title: string;
  icon?: IconType;
};

export const items: ItemType[] = [
  {
    key: 1,
    icon: MdDashboard,
    link: "/",
    title: "Dashboard",
  },
  {key: 2, icon: FaUser, link: "/users", title: "Users"},
  {
    key: 3,
    icon: HiLightBulb,
    link: "/opportunity",
    title: "Opportunity",
  },
  {
    key: 4,
    icon: FaRunning,
    link: "/training",
    title: "Training",
  },
  {
    key: 5,
    icon: FaBlog,
    link: "/blog",
    title: "Blog",
  },
  {
    key: 6,
    icon: FaBuilding,
    link: "/companies",
    title: "Company",
  },
  {
    key: 7,
    icon: FaCogs,
    link: "/services",
    title: "Services",
  },
  {
    key: 8,
    icon: RiCustomerService2Fill,
    link: "/request",
    title: "Service Request",
  },
  {
    key: 9,
    icon: BsFillMegaphoneFill,
    link: "/notification",
    title: "Notification",
  },
];
